<template>
  <div class="page">
    <div class="mt10 content-box">
      <city-select
        :cate-id="8"
        :search-key="searchKey"
        :search-stop="true"
        @searchKey="search($event)"
      ></city-select>
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="levelFilterValue"
          :options="levelOption"
          @change="filter"
        />
        <van-dropdown-item
          v-model="sortFilterValue"
          :options="sortOption"
          @change="filter"
        />
      </van-dropdown-menu>

      <div class="body-box">
        <van-list
          v-model="loading"
          :error.sync="error"
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          :offset="100"
          error-text="请求失败，点击重新加载 E"
          @load="getHospitalsList"
        >
          <div
            v-for="item in hospitalList"
            :key="item.brandShopId"
            style="margin: 8px; background-color: #ffffff; border-radius: 8px"
          >
            <van-row>
              <van-col span="6">
                <van-image
                  :src="item.logo"
                  style="width: 56px; margin-left: 16px; margin-top: 20px"
                  @click="
                    $router.push({
                      path: 'health-detail',
                      query: { id: item.brandShopId },
                    })
                  "
                ></van-image>
              </van-col>
              <van-col
                span="18"
                style="padding: 16px 0"
                @click="
                  $router.push({
                    path: 'health-detail',
                    query: { id: item.brandShopId },
                  })
                "
              >
                <van-row>
                  <van-col
                    span="24"
                    style="font-size: 18px; font-weight: 600; color: #4a4a4a"
                    >{{ item.name }}</van-col
                  >
                </van-row>
                <van-row class="van-hairline--bottom">
                  <van-col span="24" style="color: #999999; font-size: 12px">
                    <van-row>
                      <van-col span="18">
                        <van-tag
                          color="#e7f5ff"
                          size="medium"
                          style="margin-right: 4px; margin-top: 8px"
                          text-color="#29a2ff"
                          >{{ item.level }}
                        </van-tag>
                        <van-tag
                          color="#e7f5ff"
                          size="medium"
                          style="margin-right: 4px; margin-top: 8px"
                          text-color="#999"
                          >提前{{ getExtInfo(item.extInfo).days }}天预约
                        </van-tag>
                      </van-col>
                      <van-col
                        span="6"
                        style="text-align: right; padding: 12px 4px"
                      >
                        <span style="">{{ item.distance }}KM</span>
                      </van-col>
                    </van-row>
                  </van-col>
                </van-row>
              </van-col>
            </van-row>

            <div
              style="padding: 8px; font-size: 14px"
              @click="
                $router.push({
                  path: 'health-detail',
                  query: { id: item.brandShopId },
                })
              "
            >
              <van-row
                v-for="goodsItem in item.goodsList"
                :key="goodsItem.name"
                style="
                  background-color: #f9f9f9;
                  padding: 4px;
                  margin-bottom: 8px;
                "
              >
                <van-col span="8">
                  <van-image :src="goodsItem.image" width="80" />
                </van-col>
                <van-col span="16">
                  <van-row>
                    <van-col>
                      <span
                        class="van-ellipsis"
                        style="
                          font-size: 16px;
                          color: #4a4a4a;
                          font-weight: 600;
                          width: 160px;
                          display: block;
                        "
                        >{{ goodsItem.name }}</span
                      >
                    </van-col>
                    <van-col
                      style="
                        float: right;
                        font-size: 14px;
                        font-weight: 600;
                        color: #999999;
                      "
                    >
                      已售{{ goodsItem.saleCount }}
                    </van-col>
                  </van-row>
                  <br />

                  <van-row style="width: 100%">
                    <van-col>
                      <img
                        alt=""
                        src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
                        style="
                          width: 24px;
                          height: 24px;
                          display: block;
                          margin-top: 4px;
                          float: left;
                        "
                      />
                      <span
                        style="
                          color: #f84f43;
                          font-size: 21px;
                          line-height: 24px;
                          display: block;
                          margin-top: 4px;
                          float: left;
                        "
                        >{{ (goodsItem.price / 100).toFixed(2) }}</span
                      >
                    </van-col>
                    <van-col span="8" style="float: right">
                      <van-button round size="small" type="info"
                        >&nbsp;&nbsp;预 约&nbsp;&nbsp;</van-button
                      >
                    </van-col>
                  </van-row>
                </van-col>
              </van-row>
              <van-row
                style="
                  font-size: 16px;
                  font-weight: bold;
                  padding: 16px;
                  text-align: center;
                  color: #999999;
                "
              >
                <van-col span="24"> 查看其它更多套餐 > </van-col>
              </van-row>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <PageFooter :active="1"></PageFooter>
  </div>
</template>

<script>
import {
  api_get_hospital_list,
  api_get_hospital_top_list,
} from "@/api/goods-api";
import PageFooter from "@/components/common/page-footer";
import CitySelect from "@/components/common/city-select";
import request from "@/util/axios";

export default {
  name: "list",

  components: { PageFooter, CitySelect },

  data() {
    return {
      topList: [],
      error: false,
      loading: false,
      finished: false,
      finishedText: "没有更多了 J",
      hospitalList: [],
      pi: 0,
      pageCount: 0,
      searchKey: "",
      levelFilterValue: "",
      sortFilterValue: 1,

      levelOption: [],

      sortOption: [
        { text: "距离优先", value: 1 },
        { text: "销量优先", value: 2 },
      ],
    };
  },

  created() {
    api_get_hospital_top_list(1, 8, true).then((res) => {
      this.topList = res.data;
    });

    this.searchKey = this.$route.query.searchKey;
    if (this.searchKey) {
      this.search(this.searchKey);
    }

    window.onscroll = this.doScroll;

    this.getHospitalFilterKey();
  },

  methods: {
    getHospitalFilterKey() {
      request.post("/mall/wx/Goods/get-hospital-filter-key").then((res) => {
        budo_log.info("#157 getHospitalFilterKey", res);

        this.levelOption = [{ text: "全部机构", value: "" }].concat(
          res?.data?.map((e) => {
            return { text: e, value: e };
          })
        );
      });
    },

    filter() {
      this.pi = 0;
      this.hospitalList = [];
      this.getHospitalsList();
    },

    search(keyVal) {
      this.pi = 0;
      this.searchKey = keyVal;
      this.hospitalList = [];
      this.getHospitalsList();
    },

    getHospitalsList() {
      this.finishedText = "加载中 C ...";
      this.pi++;
      if (this.pi > this.pageCount && this.pageCount > 0) {
        this.finishedText = "看看其它的吧 C";
        this.finished = true;
        return;
      }

      api_get_hospital_list(
        this.pi,
        10,
        this.searchKey,
        this.levelFilterValue,
        this.sortFilterValue
      )
        .then((res) => {
          this.pageCount = res.data.pages;
          this.hospitalList = this.hospitalList.concat(res.data.records);
          budo_log.info("#188 api_get_hospital_list", res.data);
          if (this.hospitalList.length >= res.data.total) {
            this.finishedText = "没有更多了 K";
            this.finished = true;
          }

          if (res.data.total === 0) {
            this.finishedText = "看看其它的吧 D";
            this.finished = true;
          }

          this.loading = false;
        })
        .catch((error) => {
          budo_log.info("#201 api_get_hospital_list", error);
          this.loading = false;
          this.error = true;
        });
    },

    getExtInfo(str) {
      const extInfo = JSON.parse(str);
      return extInfo;
    },

    doScroll() {
      if (this.timerId) clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // 获取页面滚动距离之后设置给当前路由的元信息
        this.$route.meta.y = window.pageYOffset;
        budo_log.info("#215 window.pageYOffset", window.pageYOffset);
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background-color: #edf0f5;
  padding-bottom: 120px;
  min-height: 100vh;

  .content-box {
    .box1 {
      padding: 0 11px;
      background-color: white;

      ::v-deep {
        .van-dropdown-menu__bar {
          box-shadow: unset;
        }
      }
    }

    .body-box {
      padding: 10px 0;

      .box2 {
        padding: 0 15px;

        .my-swipe {
          border-radius: 5px;

          .van-swipe-item {
            color: #fff;
            font-size: 20px;
            line-height: 150px;
            text-align: center;
            background-color: #39a9ed;
          }
        }
      }

      .box3 {
        padding: 0 15px;
        color: #9a9a9a;
        font-size: 12px;
        margin: 14px 0;
      }

      .box4 {
        // height: 100px;
        background: #ffffff;
        border-radius: 5px;
        padding: 10px;
        font-size: 12px;
        color: #333333;
      }

      .box5 {
        background: #ffffff;
        border-radius: 8px;
        margin: 10px 15px;
      }

      .box7 {
        background: #ffffff;
        border-radius: 8px;
        margin: 10px 15px;
      }

      .box6 {
        padding: 0;

        .goods-box {
          margin-top: 10px;

          .goods-item {
            width: 133px;
            height: 261px;
            background: #ffffff;
            border-radius: 4px;
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>
